"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M315.6 269.5v9.5c0 88.2-69.2 193.2-193.3 193.2-38.2 0-71.6-9.5-105-28.6H34c33.4 0 62-9.5 85.9-28.6-28.6 0-54.9-19.1-62-45.3h11.9c7.2 0 11.9 0 16.7-2.4-31-9.5-54.9-35.8-54.9-66.8 11.9 2.4 23.9 7.2 33.4 7.2-19.1-11.9-31-33.4-31-57.2 0-11.9 2.4-23.8 9.5-33.4 33.4 38.2 81.1 69.2 140.8 71.5 0-7.2-2.4-9.5-2.4-16.7 0-35.8 28.6-69.2 69.2-69.2 19.1 0 35.8 9.5 50.1 23.8 16.7-2.4 28.6-9.5 43-16.7-7.2 16.7-16.7 28.6-28.6 35.8 11.9 0 26.2-7.2 38.2-9.5-11.9 14.4-26.2 26.3-38.2 33.4zm90.3-241.7h-41.7c-40.3 0-72.9 32.6-72.9 72.9 0 29.1 17 54.2 41.7 65.9v20c0 7 8.4 10.4 13.3 5.5l15.2-18.6c.9 0 1.8.1 2.7.1h41.7c40.3 0 72.9-32.6 72.9-72.9 0-40.3-32.6-72.9-72.9-72.9z"
  });
};

exports.default = _default;